module.exports = __webpack_public_path__ + "static/media/EDA61KLogo.4a4b4f11.png";